<template>
  <drag-btn
    v-if="train_type || train_type == 0"
    :lockedX="true"
    :lockedY="false"
    :offset="[0, 0, 0, 0]"
    class="initial-class"
    :class="[type === 'left' ? 'radius-right' : 'radius-left']"
  >
    <div class="cus-live" @click="goTrainDetails">
      <img
        class="icon"
        :src="`${cdnPath}/zhibo/static/img/live-h5/common/icon-live.png`"
        alt=""
      />
      <span>返回课程</span>
    </div>
  </drag-btn>
</template>
<script>
import { isMiniApp, getEnv } from '@/utils/utils'
import useIframe from '@/pages/study/composables/useIframe'
import dragBtn from './dragBtn.vue'
import { TRAIN_VALUE } from '@/pages/study/js/common.js'
import { STUDY_ROUTE_NAME } from '@/router/modules/study.router'
export default {
  name: 'ProbackToLive',
  props: {
    type: {
      type: String,
      default: 'left',
    },
    fromRoute: {
      type: String,
      default: '',
    },
  },
  components: { dragBtn },
  data() {
    return {
      train_type: null,
      train_params: null,
    }
  },
  computed: {
    trainFrameStore() {
      return useIframe()
    },
  },
  methods: {
    goTrainDetails() {
      if (isMiniApp('vzanlive') && history.length === 1) {
        // 微赞小程序webview历史栈为1 关闭webview页面 否则正常回退h5
        wx.miniProgram.navigateBack()
      } else {
        if (Object.values(STUDY_ROUTE_NAME).includes(this.fromRoute)) {
          this.$router.go(-1)
          return
        }
        const baseUrl = `${
          getEnv() == 'dev' ? 'https://wx-dev.vzan.com' : window.location.origin
        }`
        const type = this.train_type
        let obj = {
          ...this.train_params,
          contentType: undefined,
        }
        const queryString = this.objectToQueryString(obj)
        if (type == TRAIN_VALUE.SPECIAL) {
          window.location.href = `${baseUrl}/live/m/special/detail?${queryString}`
        } else if (type == TRAIN_VALUE.CAMP) {
          window.location.href = `${baseUrl}/live/m/camp/detail?${queryString}`
        } else if (type == TRAIN_VALUE.COURSE) {
          window.location.href = `${baseUrl}/live/m/course/detail?${queryString}`
        } else if (type == TRAIN_VALUE.IMAGETEXT) {
          window.location.href = `${baseUrl}/live/m/image-text/detail?${queryString}`
        } else if (type == TRAIN_VALUE.AUDIO) {
          window.location.href = `${baseUrl}/live/m/audio/detail?${queryString}`
        } else if (type == TRAIN_VALUE.VIDEO) {
          window.location.href = `${baseUrl}/live/m/video/detail?${queryString}`
        }
      }
    },
    objectToQueryString(obj) {
      const params = new URLSearchParams()
      for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
          const value = obj[key]
          if (value === null || value === undefined) continue // 过滤空值
          if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v)) // 展开数组
          } else if (typeof value === 'object') {
            params.append(key, JSON.stringify(value)) // 序列化对象
          } else {
            params.append(key, value)
          }
        }
      }
      return params.toString()
    },
  },
  mounted() {
    if (this.trainFrameStore.isFrame) {
      this.train_type = null
      this.train_params = null
    } else {
      if (this.$route.query && this.$route.query.Tfrom) {
        this.train_params = JSON.parse(atob(this.$route.query.Tfrom))
        console.log(this.train_params)
        this.train_type = this.train_params.contentType
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.cus-live {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #006cff;
  line-height: 12px;
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
}
.initial-class {
  height: 0.33rem;
  box-sizing: content-box;
  position: fixed;
  top: calc(100% - 2rem);
  font-size: 0.14rem;
  color: #006cff;
  z-index: 9989;
  touch-action: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #e6f1ff 0%, #f5f9ff 100%);
  box-shadow: 0.04rem 0.1rem 0.6rem 0.1rem rgba(0, 0, 0, 0.08);
  border-radius: 0 0.3rem 0.3rem 0;
  border: 0.04rem solid #ffffff;
  &.radius-right {
    width: 0.78rem;
    padding: 0 0.12rem 0 0.08rem;
    border-radius: 0 0.2rem 0.2rem 0;
    left: 0;
  }
  &.radius-left {
    width: 0.84rem;
    padding: 0 0.08rem 0 0.12rem;
    border-radius: 0.2rem 0 0 0.2rem;
    right: 0;
  }
  .wrap {
    display: flex;
    align-items: center;
  }
  .icon {
    width: 0.16rem;
    height: 0.16rem;
    margin-right: 0.04rem;
  }
  // .back-to-live {
  //   font-size: 16px;
  //   background: white;
  // }
}
</style>
